import { Dialog, Grid, IconButton, Button, LinearProgress, CircularProgress, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { detectSignals } from "../../../utils/signalDetection"
import BgComponent from '../../Auth/Components/BgComponent';
import Logo from '../../../assets/image/logo/logo.png'
import axios from 'axios'
import { TAAPI_API_KEY } from '../../../shared/taapiConfig';
import { errorToaster, successToaster } from '../../../util/toaster';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { backtest, getIndicatorAPI, getLeftIndicatorAPI } from '../../../services/Stock';
import { useUser } from '../../../context/UserContext';
import Supabase from '../../../backend/client';
import { getuuid } from '../../../util/functions';
import { useNavigate } from 'react-router-dom';
import RHFTextField from '../../../components/controls/RHFTextField';
import { useForm } from 'react-hook-form';
import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ALGO_STATUS } from '../../../shared/constant';
import RHFTextareaMaterial from '../../../components/controls/RHFTextareaMaterial';

const RunTestDialog = ({
    open,
    handleClose,
    dndRequest
}) => {
    const user = useUser();
    const userDetails = user?.user;
    const userId = user?.user?.id;
    const navigate = useNavigate();
    const [defaultStockList, setDefaultStockList] = useState([]);
    const [selectedStock, setSelectedStock] = useState("");
    const [selectedStockList, setSelectedStockLst] = useState([]);

    const [initiateRun, setInitiateRun] = useState(false);
    const [algoResult, setAlgoResult] = useState([]);
    const [runWithSuccess, setRunWithSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const schema = object({
        title: string().required().label("Algo. Title"),
        desc: string().required().label("Algo. Description"),
    });

    const { control, formState: {errors}, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    })

    useEffect(() => {
        const api = `https://api.taapi.io/exchange-symbols?secret=${TAAPI_API_KEY}&type=stocks`;
        axios.get(api)
            .then((res) => {
                const list = res?.data?.map((item) => ({ name: item, symbol: item }))
                setDefaultStockList(list);
            })
            .catch((error) => {
                console.log("error", error)
            })
    }, [])

    const handleStockPick = (e) => {
        const filter = defaultStockList?.filter((item) => e?.target?.value === item?.symbol)
        const temparr = [...selectedStockList, ...filter]
        setSelectedStockLst(temparr);
    }

    const removeSelected = (val) => {
        const filter = selectedStockList?.filter((item) => val?.symbol !== item?.symbol)
        setSelectedStockLst(filter);
    }

    const setCandleDataBuy = (candles, buyObj) => {
        if (candles?.length) {
            const processedData = candles;
            
            // Extract operator based on operation type
            let operator = buyObj?.operationType || 'crossover_above';
            console.log(`[Crossover Debug] Buy operator: ${operator}`);
            
            // Ensure we're extracting the right threshold value
            let threshold;
            if (typeof buyObj?.rightLogic?.value === 'object') {
                console.log(`[Crossover Debug] Buy threshold is an object, extracting value property`);
                threshold = parseFloat(buyObj?.rightLogic?.value?.value || 0);
            } else {
                threshold = parseFloat(buyObj?.rightLogic?.value || 0);
            }
            
            console.log(`[Crossover Debug] Buy threshold value: ${threshold}, type: ${typeof threshold}`);
            
            if (isNaN(threshold)) {
                console.error(`[Crossover Debug] Invalid threshold value: ${buyObj?.rightLogic?.value}`);
                console.log(`[Crossover Debug] Right logic object: ${JSON.stringify(buyObj?.rightLogic)}`);
                return null;
            }
            
            console.log(`[Crossover Debug] Processed data first item:`, 
                processedData.length > 0 ? processedData[0] : 'No data'
            );
            
            // Use the detectSignals utility for consistent signal detection
            const breakIndex = detectSignals(processedData, operator, threshold, false, { debug: true, indicatorType: buyObj?.leftLogic?.componentName?.toLowerCase() });
            console.log(`[Crossover Debug] Buy signal detection result: ${breakIndex !== null ? `Found at index ${breakIndex}` : 'Not found'}`);
            
            return breakIndex;
        }
        console.log(`[Crossover Debug] No data available for buy signal detection`);
        return null;
    }

    const setCandleDataSell = (candles, sellObj) => {
        if (candles?.length) {
            const processedData = candles;
            
            // Extract operator based on operation type
            let operator = sellObj?.operationType || 'crossover_below';
            console.log(`[Crossover Debug] Sell operator: ${operator}`);
            
            // Ensure we're extracting the right threshold value
            let threshold;
            if (typeof sellObj?.rightLogic?.value === 'object') {
                console.log(`[Crossover Debug] Sell threshold is an object, extracting value property`);
                threshold = parseFloat(sellObj?.rightLogic?.value?.value || 0);
            } else {
                threshold = parseFloat(sellObj?.rightLogic?.value || 0);
            }
            
            console.log(`[Crossover Debug] Sell threshold value: ${threshold}, type: ${typeof threshold}`);
            
            if (isNaN(threshold)) {
                console.error(`[Crossover Debug] Invalid threshold value: ${sellObj?.rightLogic?.value}`);
                console.log(`[Crossover Debug] Right logic object: ${JSON.stringify(sellObj?.rightLogic)}`);
                return null;
            }
            
            console.log(`[Crossover Debug] Processed data first item:`, 
                processedData.length > 0 ? processedData[0] : 'No data'
            );
            
            // Use the detectSignals utility for consistent signal detection
            const breakIndex = detectSignals(processedData, operator, threshold, false, { debug: true, indicatorType: sellObj?.leftLogic?.componentName?.toLowerCase() });
            console.log(`[Crossover Debug] Sell signal detection result: ${breakIndex !== null ? `Found at index ${breakIndex}` : 'Not found'}`);
            
            return breakIndex;
        }
        console.log(`[Crossover Debug] No data available for sell signal detection`);
        return null;
    }

    const buyExecution = async (buyObj, sellObj, stock, isSellActive) => {

        const rightInterval = buyObj?.rightLogic?.interval;
        const rightPeriod = buyObj?.rightLogic?.timeRange;
        const rightIndicator = buyObj?.rightLogic?.componentName?.toLowerCase()

        // Log the complete buy object to see what we're working with
        console.log("[Debug] Buy object:", JSON.stringify(buyObj, null, 2));
        
        const buyRightValue = await getIndicatorAPI(buyObj, stock?.symbol, rightIndicator, rightPeriod, rightInterval)
        console.log("[Debug] Buy right value (indicator value):", buyRightValue);
        
        const buyLeftValues = await getLeftIndicatorAPI(buyObj, stock?.symbol, true)
        console.log("[Debug] Buy left values (candles):", JSON.stringify(buyLeftValues?.data?.slice(0, 3)));

        // Fix: Ensure we're using the correct operation type for RSI crossover based on UI
        if (rightIndicator === 'rsi') {
            // For buy conditions with RSI, we typically want "crossover_above"
            if (buyObj.operationType !== 'crossover_above') {
                console.log("[Debug] Fixing buy operation type for RSI - was:", buyObj.operationType);
                buyObj.operationType = 'crossover_above';
                console.log("[Debug] Setting buy operation type to: crossover_above");
            }
        }

        // Check buy operation type
        console.log("[Debug] Buy operation type:", buyObj?.operationType);
        console.log("[Debug] Buy right value threshold:", buyObj?.rightLogic?.value);

        const buyData = [...buyLeftValues?.data];
        const buyCandles = buyData?.splice(0, 1);

        const buyBreakIndex = setCandleDataBuy(buyData, buyObj)
        console.log("[Debug] Buy break index result:", buyBreakIndex);
        
        let breakPointcandle = null;
        let buyTxnObj = null;
        if (buyBreakIndex !== null) {
            breakPointcandle = buyCandles?.reverse()[buyBreakIndex]
            console.log("[Debug] Buy breakpoint candle:", breakPointcandle);
        }

        if (breakPointcandle !== null) {
            buyTxnObj = { ...breakPointcandle, buyOn: buyObj?.leftLogic?.status, buyQty: buyObj?.qty || buyObj?.shares, success: true, trigger: false };
        } else {
            // trigger need to add
            buyTxnObj = { buyOn: buyObj?.leftLogic?.status, buyQty: buyObj?.qty || buyObj?.shares, success: false, trigger: true };
        }

        let sellTxnObj = null;
        if (buyTxnObj && isSellActive) {
            console.log("[Debug] Processing sell signal after successful buy");
            
            const sellRightIndicator = sellObj?.rightLogic?.componentName?.toLowerCase();
            
            const sellRightValue = await getIndicatorAPI(sellObj, stock?.symbol, sellRightIndicator, sellObj?.rightLogic?.timeRange, sellObj?.rightLogic?.interval)
            console.log("[Debug] Sell right value (indicator):", sellRightValue);
            
            const sellLeftValues = await getLeftIndicatorAPI(sellObj, stock?.symbol, true);
            console.log("[Debug] Sell left values (candles):", JSON.stringify(sellLeftValues?.data?.slice(0, 3)));
            
            // Fix: Ensure we're using the correct operation type for RSI sell condition based on UI
            if (sellRightIndicator === 'rsi') {
                // For sell conditions with RSI, we typically want "crossover_below"
                if (sellObj.operationType !== 'crossover_below') {
                    console.log("[Debug] Fixing operation type for RSI sell - was:", sellObj.operationType);
                    sellObj.operationType = 'crossover_below';
                    console.log("[Debug] Setting sell operation type to: crossover_below");
                }
            }
            
            // Check sell operation type
            console.log("[Debug] Sell operation type:", sellObj?.operationType);
            console.log("[Debug] Sell right value threshold:", sellObj?.rightLogic?.value);

            const sellData = [...sellLeftValues?.data]
            const sellCandles = sellData?.splice(0, 1);

            const sellBreakIndex = setCandleDataSell(sellData, sellObj)
            console.log("[Debug] Sell break index result:", sellBreakIndex);
            
            let sbreakPointcandle = null
            if (sellBreakIndex !== null) {
                sbreakPointcandle = sellCandles?.reverse()[sellBreakIndex]
                console.log("[Debug] Sell breakpoint candle:", sbreakPointcandle);
            }
            if (sbreakPointcandle !== null) {
                sellTxnObj = { ...sbreakPointcandle, sellOn: sellObj?.leftLogic?.status, sellQty: sellObj?.qty || sellObj?.shares, success: true, trigger: false };
            }
            else {
                // trigger needs to be added for sell
                sellTxnObj = { sellOn: sellObj?.leftLogic?.status, sellQty: sellObj?.qty || sellObj?.shares, success: false, trigger: true };
            }
        }

        return { buyTxnObj, sellTxnObj, stock }
    }

    console.log(errors)

    const runTestAlgo = async (data) => {
        try {
            const alogId = getuuid('ALGO')
            setLoading(true)
            if (!selectedStockList?.length) return errorToaster("Please select stocks.")

            const buyReq = dndRequest?.filter((item) => item?.type === 'BUY')
            const sellReq = dndRequest?.filter((item) => item?.type === 'SELL')

            // buy and sell section check
            const backtestRes = await backtest(dndRequest, selectedStockList);

            const createObj = {
                user_id: userDetails?.id,
                username: userDetails?.user_metadata?.name,
                left_logic: JSON.stringify(buyReq),
                right_logic: JSON.stringify(sellReq),
                algo_price: 0,
                algo_custom_id: getuuid("ALGO"),
                used_counter: 0,
                title: data?.title,
                description: data?.desc,
                status: ALGO_STATUS?.Private ,
                backtest_details: JSON.stringify({...backtestRes?.backtestResult, stocks: selectedStockList}) ,
            };

            await Supabase.from("algos").insert([createObj]).select();

            const buyinfo = await Promise.all(selectedStockList?.map((stock) => {
                return buyExecution(buyReq[0], sellReq[0], stock, true)
            }));

            await Promise.all(buyinfo?.map((item) => {
                const { buyTxnObj, sellTxnObj, stock } = item;
                let buyPrice = 0;
                if (buyTxnObj?.success) {
                    buyPrice = buyTxnObj?.result[buyTxnObj?.buyOn?.toLowerCase()]
                }

                const createbuyObj = {
                    stock_symbol: stock?.symbol,
                    txn_type: "buy",
                    left_logic: JSON.stringify(buyReq[0]?.leftLogic),
                    right_logic: JSON.stringify(buyReq[0]?.rightLogic),
                    price: buyPrice,
                    qty: buyTxnObj?.buyQty || buyReq[0]?.shares || buyReq[0]?.qty || 0, 
                    txn_date: new Date(), 
                    user_id: userId,
                    is_txn_done: false, 
                    algo_custom_id: alogId
                }

                const serviceArr = [];
                serviceArr.push(
                    Supabase
                        .from('stock_txn')
                        .insert([
                            createbuyObj
                        ])
                        .select()
                );

                if (sellTxnObj) {
                    let sellPrice = 0;
                    if (sellTxnObj?.success) {
                        sellPrice = sellTxnObj?.result[sellTxnObj?.sellOn?.toLowerCase()]
                    }
                    
                    const createsellObj = {
                        stock_symbol: stock?.symbol,
                        txn_type: "sell",
                        left_logic: JSON.stringify(sellReq[0]?.leftLogic),
                        right_logic: JSON.stringify(sellReq[0]?.rightLogic),
                        price: sellPrice,
                        qty: sellTxnObj?.sellQty || sellReq[0]?.shares || sellReq[0]?.qty || 0, 
                        txn_date: new Date(), 
                        user_id: userId,
                        is_txn_done: false, 
                        algo_custom_id: alogId
                    }
                    serviceArr.push(
                        Supabase
                            .from('stock_txn')
                            .insert([
                                createsellObj
                            ])
                            .select()
                    );
                }

                return Promise.all(serviceArr)
            }))
            setLoading(false)
            successToaster("Algo Run successfully and trigger added.")
            navigate('/dashboard');
        }
        catch(error){
            console.log("error",error)
        }

    }

    const runBackTest = async () => {
        try {
            setLoading(true)
            if (selectedStockList.length === 0) {
                errorToaster("Please select a stock first");
                setLoading(false)
                return;
            }
            const stock = selectedStock ? { symbol: selectedStock } : { symbol: selectedStockList[0] };
            console.log("Running backtest with stock:", stock.symbol);
            console.log("dndRequest", dndRequest);

            const result = await backtest(dndRequest, stock);
            console.log("Backtest result:", result);

            if (result?.success) {
                setAlgoResult([...algoResult, result?.data]);
                setRunWithSuccess(true);
                setLoading(false)
                successToaster("Back test completed");
                
                // Store the backtest results in localStorage for persistence
                if (window.localStorage) {
                    window.localStorage.setItem('lastBacktestStats', JSON.stringify(result));
                    window.localStorage.setItem('lastBacktestTime', new Date().toISOString());
                }
            } else {
                errorToaster(result?.message || "Error running backtest");
                setRunWithSuccess(false);
                setLoading(false)
            }
        } catch (err) {
            console.error("Backtest error:", err);
            errorToaster(err?.message || "Error running backtest");
            setRunWithSuccess(false);
            setLoading(false)
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen
        >
            <div className='flex flex-row w-full h-[100vh]'>
                <div className='lg:flex flex-[0.40] xs:hidden'>
                    <BgComponent
                        bgImg="bg-stock-bg"
                        customBack={true}
                        backAction={handleClose}
                    >
                        <p className='text-white xl:text-[50px] lg:text-[40px] font-bold absolute bottom-40 xl:left-28 lg:left-16' >
                            Freedom for <br />things that matter.
                        </p>
                    </BgComponent>
                </div>
                <div className='flex md:flex-[0.60] xs:flex-[0.80] flex-col lg:max-w-[550px] mx-auto xs:pt-[80px] md:pt-[40px] md:justify-center'>
                    <a href="/"><img src={Logo} className='relative xs:w-[120px] md:w-[170px]' /></a>
                    {
                        loading ?
                            <div className='xs:py-4 md:py-12 xl:px-0' align="center" >
                                <CircularProgress />
                                <p>
                                Algo Running ...
                                </p>
                            </div>
                            :
                            <div className='xs:py-4 md:py-12 xl:px-0' >
                                <p className='xs:text-[22px] md:text-[35px] font-bold font-sans' >
                                    Would you like to invest in <br />a specific sector?
                                </p>
                                <RHFTextField 
                                        name="title" 
                                        id="title"  
                                        control={control} 
                                        errorObj={errors}
                                        className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px]  text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg w-[400px]"
                                        placeholder="Algo title"
                                        isControlled={true}
                                    />
                                <RHFTextareaMaterial 
                                        name="desc" id="desc"  control={control} errorObj={errors}
                                        className="mt-[10px] px-[10px] xs:py-[5px] md:py-[10px]  text-[12px] text-[#7A86A1] border-[1px] border-[#7A86A1] rounded-lg  w-[400px]"
                                        placeholder="Algo description"
                                        isControlled={true}
                                        rows={3}
                                    />
                                <p className='text-[#7A86A1] text-xs md:text-sm'>
                                    Choose from stocks below
                                </p>
                                <div>
                                    <select name="stocks" id="stocks" defaultValue={selectedStock} onChange={handleStockPick} className='w-[400px] p-2 my-[10px] border-[1px] border-[#7A86A1] rounded-lg ' placeholder='Select Stocks' >
                                        <option>None</option>
                                        {
                                            defaultStockList?.map((stock, i) => {
                                                const check = selectedStockList?.find((item) => item?.symbol === stock?.symbol)
                                                if (!check) {
                                                    return (
                                                        <option key={i} value={stock?.symbol} >
                                                            {stock?.name}
                                                        </option>
                                                    )
                                                }
                                                return
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='flex gap-5 py-2 flex-wrap' >
                                    {
                                        selectedStockList?.map((item, i) => {
                                            return (
                                                <div key={i} className='text-white py-2 px-5 bg-[#B9B9B9] rounded-md '  >
                                                    {
                                                        item?.name
                                                    }
                                                    &nbsp;&nbsp;&nbsp;
                                                    <button onClick={() => removeSelected(item)} >
                                                        x
                                                    </button>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <div>
                                    <Button variant="contained" onClick={handleSubmit(runTestAlgo)} >
                                        Run Test
                                    </Button>
                                </div>
                            </div>
                    }

                </div>
            </div>
        </Dialog>
    )
}

export default RunTestDialog